import React, { useState, useEffect } from "react";
import {
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
  DigitalOrderSystem,
} from "../common/common";
import {
  Edit,
  SimpleForm,
  FormDataConsumer,
  ReferenceField,
  TextField,
  TextInput,
  SelectInput,
  TopToolbar,
  RefreshButton,
  ListButton,
  ShowButton,
  ArrayInput,
  SimpleFormIterator,
  required,
  regex,
  minValue,
  maxValue,
  maxLength,
  usePermissions,
  Labeled,
  SaveButton,
  Button,
  DeleteButton,
  Toolbar,
  useRedirect,
  useGetOne,
  DateInput,
  useRecordContext
} from "react-admin";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { getLocalStorageKey } from "../common/common";
import { CamelCaseField } from "./common";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  getDigitalOrderStatusChoices,
  getTimeInterval,
} from "../common/common";
import { useForm, Controller } from "react-hook-form";
import Select from 'react-select';

import Swal from "sweetalert2";

const validateSpecialCharacters = [
  regex(/^[A-Za-z0-9 ]+$/, "Enter a valid comment"),
  required(),
];

const validateQuantity = [
  minValue(0.1, "add at least one quantity"),
  regex(/^[0-9. ]+$/, "Enter a valid quantity"),
  required(),
  maxValue(5000, "5000 max value that can be added"),
  maxLength(5),
];

const minDateVal = new Date().toISOString().replace(/T.*/, "");

const maxDateValCal = new Date();
maxDateValCal.setMonth(maxDateValCal.getMonth() + 1);
const maxDateValue = maxDateValCal.toISOString().replace(/T.*/, "");
const maxDateVal = moment(maxDateValue).add(1, "days").format("YYYY-MM-DD");

const deliveryFromDateDelivered = [
  minValue(
    minDateVal,
    `minimum ${moment(new Date()).format("DD/MM/YYYY")} required`
  ),
  maxValue(
    maxDateVal,
    `maximum ${maxDateValue
      .replaceAll("-", "/")
      .split("/")
      .reverse()
      .join("/")} allowed`
  ),
  required(),
];

const deliveryFromDateCollect = [
  minValue(
    minDateVal,
    `minimum ${moment(new Date()).format("DD/MM/YYYY")} required`
  ),
  maxValue(
    maxDateValue,
    `maximum ${maxDateValue
      .replaceAll("-", "/")
      .split("/")
      .reverse()
      .join("/")} allowed`
  ),
  required(),
];

const EditActions = ({ basePath, data }) => (
  <TopToolbar>
    <RefreshButton />
    <ListButton basePath={basePath} />
    <ShowButton basePath={basePath} record={data} />
  </TopToolbar>
);

const DigitalOrdersEdit = ({ ...props }) => {
  const record = useRecordContext();
  const { control, setValue, watch, formState: { isDirty },trigger } = useForm({
    defaultValues:record
  });
  const [openingTime, setOpeningTime] = useState(null);
  const [openingTimeIndex, setOpeningTimeIndex] = useState(null);
  const [closingTime, setClosingTime] = useState(null);
  const [closingTimeIndex, setClosingTimeIndex] = useState(null);
  const [closingTimeChoices, setClosingTimeChoices] = useState([]);
  
  const deliveryTimePref = watch("delivery_time_pref");
  const siteOpeningTime = watch("site_opening_time");
  const siteClosingTime = watch("site_closing_time");

  
  const [closingTimeOptions, setClosingTimeOptions] = useState([]);
  const { permissions } = usePermissions();
  const location = useLocation();
  const path = location?.pathname.split("/");

  const [index, setIndex] = useState(null);
  const localStorageLocale = getLocalStorageKey("locale");
  const countryCodeArray = localStorageLocale.split("-");
  const countryCode = countryCodeArray[1];
  const redirect = useRedirect();
  const { data } = useGetOne("sap_digital_app_orders", { id: path[2] });

  // console.log('country code', countryCode);

  // const dateParser = (value) => {
  //   const dateStamp = value;
  //   const timeStamp = data?.delivery_date_from.slice(10);
  //   const updatedDate = dateStamp + timeStamp;
  //   // console.log('updated date', updatedDate);
  //   if (data?.mode_of_delivery === "delivered") {
  //     return updatedDate;
  //   } else {
  //     return moment(dateStamp).format("YYYY-MM-DD");
  //   }
  // };

  const dateParser = (value) => {
    if (!value) return;

    const parsedDate = moment(value, ["DD/MM/YYYY", "MM/DD/YYYY", "YYYY-MM-DD"]).toDate();

    if (data?.mode_of_delivery === "delivered" && data?.delivery_date_from) {
      const timePart = data.delivery_date_from.slice(10);
      return moment(parsedDate).format("YYYY-MM-DD") + timePart;
    }

    return moment(parsedDate).format("YYYY-MM-DD");
  };


  // Memoize openingTimeChoices to avoid infinite re-renders
  // const openingTimeChoices = React.useMemo(
  //   () => getTimeInterval(0, false, deliveryTimePref),
  //   [deliveryTimePref]
  // );


  // Update closingTimeChoices dynamically when siteOpeningTime changes
  // const handleOpeningTimeChange = (value) => {
  //   const updatedClosingTimeChoices = getTimeInterval(value, true, deliveryTimePref);
  //   setClosingTimeChoices(updatedClosingTimeChoices);

  //   // Set default closing time to the next available slot
  //   const nextIndex = value + 1;
  //   if (nextIndex < updatedClosingTimeChoices.length) {
  //     setValue("site_closing_time", nextIndex);
  //   } else {
  //     setValue("site_closing_time", 0);
  //   }
  // };

  useEffect(() => {
    setClosingTimeChoices(getTimeInterval(0, true, data?.delivery_time_pref,true));    
  }, [deliveryTimePref]);


  useEffect(() => {
    if (
      data?.customer_order_status !== "0" &&
      DigitalOrderSystem() !== "isManual"
    ) {
      redirect(`/sap_digital_app_orders/${path[2]}/show`);
    }
    if (data?.mode_of_delivery === "delivered") {
      setOpeningTime(moment(data?.delivery_date_from).format("HH:mm"));
      setClosingTime(moment(data?.delivery_to_date).format("HH:mm"));
      // setIndex(
      //   getTimeInterval(0, false, data?.delivery_time_pref).findIndex(
      //     (x) => x.name === moment(data?.delivery_date_from).format("HH:mm")
      //   )
      // );
    }
    // console.log('date value', data?.delivery_date_from);
  }, []);

  // useEffect(() => {
  //   if (data && data?.mode_of_delivery === "delivered") {
  //     const openTimeIndex = getTimeInterval(
  //       0,
  //       false,
  //       data.delivery_time_pref
  //     ).findIndex(
  //       (x) =>
  //         x.name === moment(data.delivery_date_from).format("HH:mm"),
  //       false
  //     );
  //     if (openTimeIndex !== -1) {
  //       setOpeningTimeIndex(openTimeIndex);
  //       setValue("site_opening_time", openTimeIndex);
        
  //     }

  //     const closeTimeIndex = getTimeInterval(
  //       0,
  //       false,
  //       data.delivery_time_pref
  //     ).findIndex(
  //       (x) =>
  //         x.name === moment(data.delivery_to_date).format("HH:mm")
  //       ,true
  //     );
  //     if (closeTimeIndex !== -1) {
  //       setClosingTimeIndex(closeTimeIndex);
  //       setValue("site_closing_time", closeTimeIndex);
        
  //     }

  //     console.log('chand ko parda',openTimeIndex,closeTimeIndex,siteOpeningTime);
  //   }
  // }, [data,getTimeInterval,setValue]);


   ///////////////////////
   // Generate time interval options
    // const generateTimeOptions = (startIndex = 0, isClosingTime = false, timePref = deliveryTimePref) => {
    //   const timeInterval = getTimeInterval(startIndex, isClosingTime, timePref);
    //   return timeInterval.map(time => ({
    //     value: time.value,
    //     label: time.name,
    //     isDisabled: time.disabled
    //   }));
    // };

    const generateTimeOptions = (startIndex = 0, isClosingTime = false, timePref = data?.delivery_time_pref) => {
      const timeInterval = getTimeInterval(startIndex, false, timePref, isClosingTime);
      return timeInterval.map(time => ({
        value: time.value,
        label: time.name,
        isDisabled: time.disabled
      }));
    };
    // Dynamic opening time options
    const openingTimeChoices = React.useMemo(() => 
      generateTimeOptions(0, false, deliveryTimePref,false),
      [deliveryTimePref]
    );

    // Handle opening time change
    const handleOpeningTimeChange = (selectedOption) => {
      if (selectedOption) {
        // Update form value
        setValue("site_opening_time", selectedOption.value, { shouldDirty: true });
        setOpeningTime(selectedOption.label);

        if (data?.delivery_time_pref != "AM") {
          // Generate closing time options based on selected opening time
          const updatedClosingTimeOptions = generateTimeOptions(
            selectedOption.value, 
            true, 
            deliveryTimePref,
            true
          );
  
          setClosingTimeOptions(updatedClosingTimeOptions);
  
          // Automatically select the next available closing time
          const nextClosingTimeIndex = selectedOption.value  < updatedClosingTimeOptions.length 
            ? selectedOption.value  
            : 0;
  
          setValue("site_closing_time", nextClosingTimeIndex, { shouldDirty: true });
          setClosingTime(updatedClosingTimeOptions[nextClosingTimeIndex].label);
          
        }

        // Trigger form validation
        trigger();
      }
    };

    const handleClosingTimeChange = (selectedOption) => {
      if (selectedOption) {
        setValue("site_closing_time", selectedOption.value, { shouldDirty: true });
        setClosingTime(selectedOption.label); // Store the time string

        trigger();
      }
    };

    // Initial data loading effect
    useEffect(() => {
      if (data?.mode_of_delivery === "delivered") {
        // Set initial opening time
        const openTimeOptions = generateTimeOptions(0, false, data.delivery_time_pref);
        const openTimeIndex = openTimeOptions.findIndex(
          (option) => option.label === moment(data.delivery_date_from).format("HH:mm")
        );

        if (openTimeIndex !== -1) {
          setValue("site_opening_time", openTimeIndex);
          
          // Generate initial closing time options
          const closingOptions = generateTimeOptions(
            openTimeIndex, 
            true, 
            data.delivery_time_pref,
            true
          );
          setClosingTimeOptions(closingOptions);

          // Set closing time
          const closeTimeOptions = generateTimeOptions(0, true, data.delivery_time_pref,true);
          const closeTimeIndex = closeTimeOptions.findIndex(
            (option) => option.label === moment(data.delivery_to_date).format("HH:mm")
          );

          if (closeTimeIndex !== -1) {
            setValue("site_closing_time", closeTimeIndex);
          }
        }
      }
    }, [data]);

    // Custom styles for react-select
    const customStyles = {
      control: (provided) => ({
        ...provided,
        minHeight: '40px',
      }),
      menu: (provided) => ({
        ...provided,
        zIndex: 9999,
      }),
    };

///////////////////


  const isButtonDisable = () => {
    if (openingTime === null && closingTime === null) {
      return false;
    } else {
      if (closingTime > openingTime) {
        return false;
      } else {
        return true;
      }
    }
  };

  const cancelEdit = (path) => {
    const splitURL = path.toString().split("/");
    const dataId = splitURL[splitURL.length - 1];
    window.location.href = `/sap_digital_app_orders/${dataId}`;
  };

  const deleteConfirm = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteData(location.pathname);
      }
    });
  };

  const deleteData = (path) => {
    const splitURL = path.toString().split("/");
    const dataId = splitURL[splitURL.length - 1];

    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "delete";
    fetch(`${apiUrl}/sap_digital_app_orders/${dataId}`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        Swal.fire("Deleted!", "Your file has been deleted.", "success");
        setTimeout(() => {
          window.location.href = "/sap_digital_app_orders/";
        }, 1000);
        // console.log("obj==>", jsonD);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const EditToolbar = () => (
    <Toolbar style={{ justifyContent: "space-between" }}>
      <Box>
        {/* <SaveButton
        // disabled={data?.mode_of_delivery === "delivered" && isButtonDisable()}
        // disabled={!isDirty}
        /> */}
        {/* <SaveButton
          disabled={!isDirty || (data?.mode_of_delivery === "delivered" && 
            (siteOpeningTime === null || siteClosingTime === null))}
        /> */}
        <SaveButton
          {...props}
          disabled={false}
          alwaysEnable={true}
        /> 
        <Button
          onClick={() => cancelEdit(location.pathname)}
          label="Cancel"
          className="cancel-button-style"
        ></Button>
      </Box>
      <Button
        label="Delete"
        className="delete-button-style icon-delete"
        onClick={() => deleteConfirm()}
      ></Button>
      {/* <DeleteButton /> */}
    </Toolbar>
  );

  // const transform = (data) => {
  //   // console.log("delivery_date_from =>",moment(openingTime, 'HH:m').utc().format("HH:mm:ss"))
  //   // let changedOpeningTime = data?.delivery_date_from.split("T")[1].split('.');
  //   console.log("delivery_date_from =>",data?.delivery_date_from)
  //   console.log("delivery_date_fromreplace string ",data?.delivery_date_from.replace(moment(data?.delivery_date_from).utc().format("HH:mm:ss"), moment(openingTime, 'HH:m').utc().format("HH:mm:ss")))

  // }

  // const transform = (data) => ({
  //   ...data,
  //   delivery_date_from:
  //     openingTime !== null
  //       ? data?.delivery_date_from.replace(
  //           moment(data?.delivery_date_from).utc().format("HH:mm:ss"),
  //           moment(openingTime, "HH:m").utc().format("HH:mm:ss")
  //         )
  //       : data?.delivery_date_from,
  //   delivery_to_date:
  //     closingTime !== null
  //       ? data?.delivery_to_date.replace(
  //           moment(data?.delivery_to_date).utc().format("HH:mm:ss"),
  //           moment(closingTime, "HH:m").utc().format("HH:mm:ss")
  //         )
  //       : data?.delivery_to_date,
  // });


  const transform = (data) => {
    if (data?.mode_of_delivery !== "delivered") return data;

    const newOpeningTime = openingTime || moment(data?.delivery_date_from).format("HH:mm");
    const newClosingTime = closingTime || moment(data?.delivery_to_date).format("HH:mm");

    return {
      ...data,
      delivery_date_from: data?.delivery_date_from.replace(
        moment(data?.delivery_date_from).utc().format("HH:mm:ss"),
        moment(newOpeningTime, "HH:mm").utc().format("HH:mm:ss")
      ),
      delivery_to_date: data?.delivery_to_date.replace(
        moment(data?.delivery_to_date).utc().format("HH:mm:ss"),
        moment(newClosingTime, "HH:mm").utc().format("HH:mm:ss")
      ),
    };
  };

  function isInRange(number, array) {
    return number >= 0 && number < array.length;
  }

  return (
    <Edit
      title="Digital Order Edit"
      actions={<EditActions permissions={permissions} />}
      redirect="show"
      mutationMode="pessimistic"
      transform={data?.mode_of_delivery === "delivered" && transform}
    >
      <SimpleForm toolbar={<EditToolbar />}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Labeled label="Sold To Name">
                <ReferenceField source="business_id" reference="businesses">
                  <TextField source="name" />
                </ReferenceField>
              </Labeled>
            </Grid>
            <Grid item xs={6}>
              <Labeled label="Mode Of Delivery">
                <CamelCaseField
                  source="mode_of_delivery"
                  label="Mode Of Delivery"
                  addLabel
                />
              </Labeled>
            </Grid>
            <Grid item xs={6}>
              <TextInput
                source="order_number"
                validate={validateSpecialCharacters}
                fullWidth
              />
            </Grid>
            <Grid item xs={6}>
              <TextInput
                fullWidth
                // label="Local purchase number"
                multiline
                source="local_po_note"
                validate={required()}
              />
            </Grid>

            <Grid item xs={2}>
              <TextInput disabled source="delivery_time_pref" />
            </Grid>
                
            <Grid item xs={4}>
              <SelectInput
                fullWidth
                source="customer_order_status"
                choices={getDigitalOrderStatusChoices()}
                validate={required()}
              />
            </Grid>
            <Grid item xs={6}>
              <DateInput
                source="delivery_date_from"
                fullWidth
                label={
                  data?.mode_of_delivery == "agency" ||
                  data?.mode_of_delivery == "delivered"
                    ? "Requested Delivery Date"
                    : "Collect Date"
                }
                // options={{ format: "d/M/y", ampm: true }}
                options={{ format: "dd/MM/yyyy",  ampm: true }}
                validate={
                  data?.mode_of_delivery === "delivered"
                    ? deliveryFromDateDelivered
                    : deliveryFromDateCollect
                }
                parse={dateParser}
              />
            </Grid>
          
            <Grid item xs={6}>
              <FormDataConsumer>
                {({ formData, ...rest }) => {
                  if (formData.customer_order_status == 0) {
                    // return (
                    //   <DateInput
                    //     source="delivery_date_from"
                    //     fullWidth
                    //     label={
                    //       formData.mode_of_delivery == "agency" ||
                    //       formData.mode_of_delivery == "delivered"
                    //         ? "Dispatch Date"
                    //         : "Pickup Date"
                    //     }
                    //     options={{ format: "d/M/y", ampm: true }}
                    //   />
                    // );
                  } else if (formData.customer_order_status == 4) {
                    return (
                      <TextInput
                        multiline
                        fullWidth
                        source="sap_order_failed_message"
                        label="Message"
                        {...rest}
                      />
                    );
                  }
                }}
              </FormDataConsumer>
            </Grid>

            <Grid item xs={6}></Grid>
            {/* <Grid item xs={6}> */}
            {/* <FormDataConsumer>
              {({ formData, ...rest }) =>
                formData.customer_order_status === 4 && (
                  <TextInput
                    multiline
                    fullWidth
                    source="sap_order_failed_message"
                    label="Message"
                    {...rest}
                  />
                )
              }
            </FormDataConsumer> */}
            {/* </Grid> */}
          </Grid>
          <>
            {data?.mode_of_delivery === "delivered" && (
              <Grid container spacing={2} alignItems="center">

                {/* <Grid item xs={2}>
                  <TextInput disabled source="delivery_time_pref" />
                </Grid>
                 */}
                <Grid item xs={4}>
                  <Controller
                    name="site_opening_time"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <div>
                      <label className="select-label">
                        {("Select Opening Time")}
                        <sup>*</sup>
                      </label>
                      <div className="select-retailer">
                        <Select
                          {...field}
                          options={openingTimeChoices}
                          styles={customStyles}
                          placeholder="Select Opening Time"
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption);
                            handleOpeningTimeChange(selectedOption);
                          }}
                          isDisabled={data?.delivery_time_pref === "PM"}
                          value={
                            openingTimeChoices.find(
                              (option) => option.value === field.value
                            ) || null
                          }
                        />
                      </div>
                    </div>
                    )}
                  />
                </Grid>
                
                <Grid item xs={4}>
                  <Controller
                    name="site_closing_time"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <div>
                      <label className="select-label">
                        {("Select Closing Time")}
                        <sup>*</sup>
                      </label>
                      <div className="select-retailer">
                        <Select
                          {...field}
                          options={closingTimeOptions}
                          styles={customStyles}
                          placeholder="Select Closing Time"
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption);
                            // setValue("site_closing_time", selectedOption.value);
                            handleClosingTimeChange(selectedOption);
                          }}
                          isDisabled={data?.delivery_time_pref === "AM"}
                          value={
                            closingTimeOptions.find(
                              (option) => option.value === field.value
                            ) || null
                          }
                        />

                      </div>
                    </div>
                    )}
                  />
                </Grid>
              </Grid>
            )}
          </>
          <FormDataConsumer>
            {({ formData, ...rest }) => {
              if (formData.mode_of_delivery === "delivered") {
                return (
                  <>
                    <Box sx={{ flexGrow: 1 }}>
                      <Grid container spacing={2}>
                        {/* <Grid item xs={12}>
                          <TextInput
                            multiline
                            fullWidth
                            label="Delivery address and contact at site "
                            source="delivery_address"
                          />
                        </Grid> */}
                        {/* <Grid item xs={6}>
                        <SelectInput
                          fullWidth
                          source="mode_of_transport"
                          choices={getModeOfTransportType()}
                        />
                      </Grid> */}
                      </Grid>
                    </Box>

                    {/* <FormDataConsumer>
                    {({ formData, ...rest }) =>
                      formData.mode_of_transport == "Truck" && (
                        <SelectInput
                          fullWidth
                          label="Truck type"
                          source="vehicle_type"
                          choices={getVehicleType()}
                        />
                      )
                    }
                  </FormDataConsumer> */}
                  </>
                );
              } else {
                return (
                  <>
                    {countryCode !== "GB" && (
                      <>
                        <Box sx={{ flexGrow: 1 }}>
                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <TextInput
                                fullWidth
                                label="Driver name"
                                source="driver_details"
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <TextInput
                                fullWidth
                                label="Truck number"
                                source="truck_number"
                              />
                            </Grid>
                          </Grid>
                        </Box>
                      </>
                    )}
                  </>
                );
              }
            }}
          </FormDataConsumer>

          {/* <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.customer_order_status == 0 && (
              <DateInput
                source="delivery_date_from"
                label={
                  formData.mode_of_delivery == "agency" ||
                  formData.mode_of_delivery == "delivered"
                    ? "Dispatch Date"
                    : "Pickup Date"
                }
                options={{ format: "d/M/y", ampm: true }}
              />
            )
          }
        </FormDataConsumer> */}
          {/* <SelectInput
          source="customer_order_status"
          choices={getDigitalOrderStatusChoices()}
        /> */}
          {/* <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.customer_order_status === 4 && (
              <TextInput
                multiline
                source="sap_order_failed_message"
                label="Message"
                {...rest}
              />
            )
          }
        </FormDataConsumer> */}
          {/* <TextInput
          label="Local purchase number"
          multiline
          source="local_po_note"
        />
        <TextInput
          multiline
          fullWidth
          label="Special Instructions"
          source="special_instructions"
        /> */}

        
          {/* {data?.mode_of_delivery === "delivered" && (
            <FormDataConsumer>
              {({ formData, ...rest }) => {
                let deliveryDatesArray = getTimeInterval(0, false, formData?.delivery_time_pref);
                console.log(
                  "Value formData => ",
                  formData,
                  getTimeInterval(0, false, formData?.delivery_time_pref),
                  openingTime,
                  closingTime,
                  openingTimeIndex,
                  closingTimeIndex
                );

                return (
                  <Grid container spacing={1}>
                    <Grid item xs={2}>
                      <TextInput disabled source="delivery_time_pref" />
                    </Grid>
                    <Grid item xs={2}>
                    <Controller
                      name="site_opening_time"
                      control={control}
                      render={({ field }) => (
                        <SelectInput
                          {...field}
                          source="site_opening_time"
                          label="Site opening time"
                          choices={openingTimeChoices}
                          // choices={getTimeInterval(
                          //   0,
                          //   false,
                          //   formData?.delivery_time_pref
                          // )}
                          validate={required()}
                          onChange={({ target: { value } }) => {
                            setOpeningTime(
                              getTimeInterval(
                                0,
                                false,
                                formData?.delivery_time_pref
                              )[value].name
                            );
                            setIndex(value);
                            setOpeningTimeIndex(value);
                            field.onChange(value);
                            handleOpeningTimeChange(value);
  
                            
                            if (isInRange(value+1,deliveryDatesArray)) {
                              const firstFieldValue = watch("site_closing_time")
                              console.log('hhihihihihihhihih',firstFieldValue);
                              setClosingTimeIndex(value+1);
                              setClosingTime(
                                getTimeInterval(
                                  0,
                                  false,
                                  formData?.delivery_time_pref
                                )[value+1].name
                              );
                              
                              setValue("site_closing_time", value);
                              
                            }else{
                              console.log('gggggggggggggggg');
                              setClosingTimeIndex(0);
                              setClosingTime(
                                getTimeInterval(
                                  0,
                                  false,
                                  formData?.delivery_time_pref
                                )[0].name
                              );
                              setValue("site_closing_time", value);
                            }
                            console.log('on change the opensite --',closingTimeChoices,closingTimeIndex);
                            
  
                            // setClosingTime(
                            //   getTimeInterval(
                            //     value,
                            //     true,
                            //     formData?.delivery_time_pref
                            //   )[value].name
                            // )
                            // setClosingTimeIndex(value)
                          }}
                          defaultValue={openingTimeIndex}
                        //   defaultValue={
                        //     getTimeInterval(
                        //     0,
                        //     false,
                        //     formData?.delivery_time_pref
                        //   ).findIndex(
                        //     (x) =>
                        //       x.name ===
                        //       moment(formData?.delivery_date_from).format("HH:mm")
                        //   )
                        // }
                          disabled={formData?.delivery_time_pref === "PM"}
                        />

                      )}
                    />
                    </Grid>
                    <Grid item xs={2}>
                    <Controller
                        name="site_closing_time"
                        control={control}
                        render={({ field }) => (
                          <SelectInput
                            {...field}
                            source="site_closing_time"
                            label="Site closing time"
                            choices={closingTimeChoices}
                            // choices={getTimeInterval(
                            //   index,
                            //   true,
                            //   formData?.delivery_time_pref
                            // )}
                            emptyValue={10}
                            validate={required()}
                            onChange={({ target: { value } }) =>{
                              field.onChange(value);
                              setClosingTime(
                                getTimeInterval(
                                  index,
                                  true,
                                  formData?.delivery_time_pref
                                )[value].name
                              )
                              setClosingTimeIndex(value)
                            }
                          }
                          defaultValue={closingTimeIndex}
                            // defaultValue={
                              // closingTimeIndex
                            //   getTimeInterval(
                            //   0,
                            //   false,
                            //   formData?.delivery_time_pref
                            // ).findIndex(
                            //   (x) =>
                            //     x.name ===
                            //     moment(formData?.delivery_to_date).format("HH:mm")
                            // )
                          // }
                            disabled={formData?.delivery_time_pref === "AM"}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                );
              }}
            </FormDataConsumer>
          )} */}


      
          
          <ArrayInput className="doli-space-top" source="digital_order_line_items" validate={required()}>
            <SimpleFormIterator
              inline
              disableAdd
              disableClear
              disableRemove
              disableReordering
            >
              <TextInput
                disabled
                label="Product Name"
                source="product_master.description"
              />
              {/* <TextInput disabled label="UOM" source="product_master.input_uom_name" /> */}
              <TextInput
                label="Quantity"
                source="quantity"
                validate={validateQuantity}
              />

              {/* <TextInput disabled label="UOM" source="product_master.input_uom_name" /> */}

              {countryCode != "FR" && (
                <FormDataConsumer>
                  {({ formData, getSource, scopedFormData }) => {
                    const lineItems = [];
                    // const { index, total, reOrder } = useSimpleFormIteratorItem();
                    scopedFormData.contract_product &&
                      scopedFormData.contract_product.forEach((product) => {
                        lineItems.push({
                          id:
                            product.product_master_id +
                            "-" +
                            product.line_number +
                            "-" +
                            product.business_unit_number,
                          name:
                            product.works_name +
                            " - " +
                            product.product_description +
                            " - " +
                            "(" +
                            product.line_number +
                            ")",
                        });
                      });
                    return (
                      <SelectInput
                        source={getSource("updated_product_master_id")}
                        label="Select E1 Product"
                        choices={lineItems}
                        validate={required()}
                        defaultValue={
                          scopedFormData.products_master_id +
                          "-" +
                          parseInt(scopedFormData.line_number) +
                          "-" +
                          parseInt(scopedFormData.plant_code)
                        }
                      />
                    );
                  }}
                </FormDataConsumer>
              )}
            </SimpleFormIterator>
          </ArrayInput>
          {data?.mode_of_delivery == "delivered" ? (
              <Grid item xs={12}>
                <TextInput
                  multiline
                  fullWidth
                  label="Special Instructions"
                  source="customer_ref_number"
                  validate={required()}
                />
              </Grid>
            ) : (
              <Grid item xs={12}>
                <TextInput
                  multiline
                  fullWidth
                  label="Special Instructions"
                  source="special_instructions"
                  validate={required()}
                />
              </Grid>
            )}
        </Box>
      </SimpleForm>
    </Edit>
  );
};

export default DigitalOrdersEdit;
